import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EndPointGetterService } from '../utilities/end-point-getter.service';
import { LauncherApp } from './models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LauncherAppService {

  constructor(private http: HttpClient, private epGetter: EndPointGetterService) { }

  getLauncherApps(): Observable<LauncherApp[]> {
    return this.http.get<LauncherApp[]>(this.epGetter.getEndPointUrl() + '/launcherapps');
  }

  getLauncherApp(id: number): Observable<LauncherApp> {
    return this.http.get<LauncherApp>(this.epGetter.getEndPointUrl() + '/launcherapps/' + id);
  }

  postLauncherApp(launcherApp: LauncherApp): Observable<any> {
    return this.http.post(this.epGetter.getEndPointUrl() + '/launcherapps', launcherApp);
  }

  putLauncherApp(launcherApp: LauncherApp): Observable<any> {
    return this.http.put(this.epGetter.getEndPointUrl() + '/launcherapps/' + launcherApp.launcherAppId, launcherApp);
  }

  deleteLauncherApp(id: number): Observable<LauncherApp> {
    return this.http.delete<LauncherApp>(this.epGetter.getEndPointUrl() + '/launcherapps/' + id);
  }

  getLauncherAppsByScenarioAndRole(scenarioId: number, roleId: number): Observable<LauncherApp[]> {
    // tslint:disable-next-line:max-line-length
    return this.http.get<LauncherApp[]>(this.epGetter.getEndPointUrl() + '/Scenarios/' + scenarioId + '/Roles/' + roleId + '/LauncherApps');
  }

  addLauncherAppsToScenarioAndRole(scenarioId: number, roleId: number, apps: LauncherApp[]): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(this.epGetter.getEndPointUrl() + '/Scenarios/' + scenarioId + '/Roles/' + roleId + '/LauncherApps', apps);
  }

  deleteLauncherAppsFromScenarioAndRole(scenarioId: number, roleId: number, apps: LauncherApp[]): Observable<any> {
    const httpOptions = {
      headers: null, body: apps
    };
    // tslint:disable-next-line:max-line-length
    return this.http.delete<any>(this.epGetter.getEndPointUrl() + '/Scenarios/' + scenarioId + '/Roles/' + roleId + '/LauncherApps', httpOptions);
  }
}
